import React, { useContext, useEffect, useState } from 'react';
import Select, { createFilter } from 'react-select';
import { useNavigate } from 'react-router-dom';
import CustomOption from '../../utils/Elements/CustomOption';
import { CountContext, ParentContext, CompanyContext, ActivityContext } from '../../layouts/Dashboard/LayoutDashboard';
import {Pagination, Button, FloatingLabel, Nav} from 'react-bootstrap';
import { CompanyCard } from './CompanyCard';
import { CompanyForm } from './CompanyForm';
import { ContactForm } from '../Contacts/ContactForm';
import { BAQForm } from './BAQForm';
import { AlertElement } from '../../utils/Elements/AlertElement';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import '../Pages.css';

export const Companies = () => {
  const api = process.env.REACT_APP_API_ENDPOINT;
  const reportServer = process.env.REACT_APP_MC3_ENDPOINT;
  const customersPagedEndpoint = `${api}/v1/customers/paged`;
  const salesRepsEndpoint = `${api}/v1/individuals/salesreps`;
  const totalSpendEndpoint = `${api}/v1/customers/totalspend`;
  const individualsEndpoint = `${api}/v1/individuals?id=`;

  const navigate = useNavigate();

  // State management
  const { setCompanyCount } = useContext(CountContext);
  const { selectedParentID } = useContext(ParentContext);
  const { selectedCompanyID } = useContext(CompanyContext);
  const { setSearchOptions } = useContext(ActivityContext);

  const [companies, setCompanies] = useState([]);

  const [allCollapsed, setAllCollapsed] = useState(0);
  const [userCollapsed, setUserCollapsed] = useState(false);
  const [collapseButtonText, setCollapseButtonText] = useState('Collapse All');

  const [showCompanyForm, setCompanyForm] = useState(false);
  const [companySelected, setCompanySelected] = useState({});

  const [showContactForm, setContactForm] = useState(false);
  const [contactSelected, setContactSelected] = useState({});

  const [showBAQForm, setBAQForm] = useState(false);
  const [reportCompany, setReportCompany] = useState({});
  

  //display options dropdown
  const [displayOptions] = useState([
    { value: 20, label: "20 Lines" },
    { value: 50, label: "50 Lines" },
    { value: 100, label: "100 Lines" },
    { value: 200, label: "200 Lines" }
  ]);
  const [displayOption, setDisplayOption] = useState(displayOptions[0]);

  //sort options dropdown
  const [sortOptions] = useState([
    { value: 0, label: "Company A-Z" },
    { value: 1, label: "Company Z-A" },
  ]);
  const [sortOption, setsortOption] = useState(sortOptions[0]);

  //prspect filter
  const [prospectFilters] = useState([
    { value: 0, label: "All" },
    { value: 1, label: "Customer" },
    { value: 2, label: "Prospect" },
  ]);
  const [prospectFilter, setProspectFilter] = useState(prospectFilters[0]);

  //individual filter
  const defaultSalesRep = { label: "All", value: 0 };
  const [salesReps, setSalesReps] = useState([defaultSalesRep]);
  const [salesRepsLoading, setSalesRepsLoading] = useState(false);
  const [salesRepFilter, setSalesRepFilter] = useState(defaultSalesRep); //0=all

  const [filterTotal, setfilterTotal] = useState(0);

  //paginaiton
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalDisplayed, setTotalDisplayed] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [loading, setLoading] = useState(false); //this dims cards when they are being refreshed

  const [filterDescription, setFilterDescription] = useState('');
  const [noRecordsMessage, setNoRecordsMessage] = useState('');

  const [refreshIndividualOptionsToggle, setRefreshIndividualOptionsToggle] = useState(false);

  const [totalSpends, setTotalSpends] = useState({});

  // Functions to handle pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFirstPage = () => {
    setCurrentPage(1);
  };
  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };
  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };
  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  //collapse management
  const collapseAll = () => {
    if (!userCollapsed) setAllCollapsed(1);
  };
  const expandAll = () => {
    if (!userCollapsed) setAllCollapsed(0);
  };
  const handleToggleCollapse = () => {
    setUserCollapsed(true);
    setAllCollapsed(1 - allCollapsed);
  };

  // Function to handle the change in cards per page
  const handleDisplayChange = (option) => {
    setDisplayOption(option);
    setCurrentPage(1); // Reset to the first page
    option.value >= 50 ? collapseAll() : expandAll();
  };

  // Function to handle Sort change
  const handleSortChange = (option) => {
    setsortOption(option);
  };

  // Function to handle Filter Contact
  const handleSalesRepFilterChange = (value) => {
    let filter = defaultSalesRep;
    if (!!value) filter = value;

    if (salesRepFilter.value === 0 && filter.value !== 0) {
      setfilterTotal(filterTotal + 1);
    } else if (salesRepFilter.value !== 0 && filter.value === 0) {
      setfilterTotal(filterTotal - 1);
    }

    setSalesRepFilter(filter);
    setCurrentPage(1);
  }

  // Function to handle Filter Contact
  const handleProspectFilterChange = (value) => {
    let filter = prospectFilters[0];
    if (!!value) filter = value;

    if (prospectFilter.value === 0 && filter.value !== 0) {
      setfilterTotal(filterTotal + 1);
    } else if (prospectFilter.value !== 0 && filter.value === 0) {
      setfilterTotal(filterTotal - 1);
    }

    setProspectFilter(filter);
    setCurrentPage(1);
  }

  const fetchTotalSpend = async (data) => {
      setTotalSpends([]);
      try {
        const CompaniesRequested = data.map((company)=>company.CustomerID);
        const response = await fetch(totalSpendEndpoint,{
          method: 'POST',
          headers: {
            Authorization:`Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          },
          body:JSON.stringify({CompaniesRequested}),
        });
        if (response.ok) {
          const data = await response.json();
          setTotalSpends(data);
        } else {
          console.error('Failed to fetch additional data');
        }
      } catch (error) {
        console.error('Error fetching total spends:', error);
      }
    };

  // Pagination Carousel
  const renderPaginationItems = () => {
    const maxVisibleItems = 5;
    const items = [];
    const startPage = Math.max(currentPage - Math.floor(maxVisibleItems / 2), 1);
    const endPage = Math.min(startPage + maxVisibleItems - 1, totalPages);

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }
    return items;
  };

  const viewActivities = (e, company) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    setSearchOptions({ mode: 2, value: company.CustomerID, data: "" });
    navigate('/activities');
  };


  const openCompanyForm = (e, company) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    setCompanyForm(true);
    console.log(company)
    setCompanySelected(company);
  };
  const openFeedback = () => {
    const url = "https://docs.google.com/forms/d/e/1FAIpQLSddmXQJBxtcMHndW_M6E5oVf82EtcCArYChWtwArf40qZx40Q/viewform";
    window.open(url, '_blank');
  };
  const closeCompanyForm = () => {
    setCompanyForm(false);
    fetchCompanies(); //refresh page
  };

  const openContactFormCallback = async (individual) => {
    //the user opened the add/edit individual from the add/edit company form
    //if label-value-pair has data then load the contact to be edited
    let contact = {};
    if (individual && individual.value !== 0) {
      //load contact
      const response = await fetch(individualsEndpoint + individual.value, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json',
        }
      });
      if (response.ok) {
        contact = await response.json();
        setContactSelected(contact);
      }

    } else {
      setContactSelected(contact);
    }
    setContactForm(true);
  };
  
  const closeContactForm = () => {
    setContactForm(false);
    //the individual modal is opened from the company form, so the company form is open now
    //the user probably added or edited an individual, so the company form individual dropdown needs to be refreshed
    //this forces a refresh of the indivudual dropdown on the company form via the async select's key property
    setRefreshIndividualOptionsToggle(prev => !prev);
  };

  const getStoredToken = () => {
    return localStorage.getItem('token');
  };

  const storedToken = getStoredToken();
  
  const fetchSalesReps = async () => {

    if (storedToken && (selectedParentID || selectedCompanyID)) {

      try {
        setSalesRepsLoading(true);

        const response = await fetch(salesRepsEndpoint + `?parentId=${selectedParentID}&companyId=${selectedCompanyID}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          data.unshift(defaultSalesRep);
          setSalesReps(data);
          setSalesRepsLoading(false);

        } else {
          setSalesReps([defaultSalesRep]);
          setSalesRepsLoading(false);
          console.error('Companies: Failed to fetch sales reps');
        }

      } catch (error) {
        setSalesReps([defaultSalesRep]);
        setSalesRepsLoading(false);
        console.error('Companies: Failed to fetch sales reps');
      }

    }

  };

  const fetchCompanies = async () => {
    if (storedToken && (selectedParentID || selectedCompanyID)) {

      setLoading(true);

      const identity = jwtDecode(storedToken);

      const payload = {
        EmployeeUID: identity.sub,
        ParentID: selectedParentID,
        CompanyID: selectedCompanyID,
        PageNo: currentPage,
        PageSize: displayOption.value,
        SortBy: 0,
        SortOrder: sortOption.value,
        FilterSalesRep: salesRepFilter.value,
        FilterProspect: prospectFilter.value,
      };

      try {
        const response = await fetch(customersPagedEndpoint, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        if (response.ok) {
          const data = await response.json();
          setCompanies(data.Customers);
          setTotalRecords(data.TotalCount);
          setTotalDisplayed(Math.min(data.Customers.length, displayOption.value));
          setTotalPages(Math.ceil(data.TotalCount / displayOption.value));
          setCompanyCount(data.UnfilteredCount);  //this sets the count on the upper nav bar
          setLoading(false);

          fetchTotalSpend(data.Customers);


        } else {
          setLoading(false);
          //console.error('Failed to fetch companies');
          toast.error("Failed to load companies", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            paueOnHover: true,
            theme: 'colored'
          });
        }
      } catch (error) {
        setLoading(false);
        //console.error('Failed to fetch companies', error);
        toast.error("Failed to load companies", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
          paueOnHover: true,
          theme: 'colored'
        });
      }

    } else {
      setCompanies([]);
      setTotalRecords(0);
      setTotalDisplayed(0);
      setTotalPages(0);
    }
  }

  const buildNoRecordsMsg = () => {
    var msg;
    if (loading) {
      msg = "Loading...please wait";
    } else if ((selectedParentID && selectedParentID !== 0) || (selectedCompanyID && selectedCompanyID !== 0)) {
      if (filterTotal === 0) {
        msg = "No Companies found.";
        //msg = "No Companies with the selected Company/Parent. <link>Remove Company/Parent Filter</link>";
      } else {
        msg = "No Companies found that match the applied filters. <link>Remove Filters</link>";
      }
    } else {
      msg = "Please select a Company Parent and/or a Company.";
    }
    setNoRecordsMessage(msg);
  };

  const buildFilterMsg = () => {
    //displaying first {totalDisplayed} Companies of {totalRecords} | {filterTotal} filters applied
    //displaying next  {totalDisplayed} Companies of {totalRecords} | {filterTotal} filters applied
    //displaying last  {totalDisplayed} Companies of {totalRecords} | {filterTotal} filters applied
    //displaying first {totalDisplayed} Companies of {totalRecords} found | {filterTotal} filters applied
    var msg;
    if (loading) {
      msg = "Loading...please wait";
    } else {
      msg = 'displaying '
        + (currentPage === 1 ? 'first' : currentPage === totalPages ? 'last' : 'next')
        + ' ' + totalDisplayed + ' Companies of ' + totalRecords + (filterTotal !== 0 ? ' found ' : '') + " | " + filterTotal + ' filters applied.';
    }
    setFilterDescription(msg);
  };

  const resetFilters = () => {
    setSalesRepFilter(defaultSalesRep);
    setProspectFilter(prospectFilters[0])
    setfilterTotal(0);
  };


  const openReport = (e, company, reportId) => {
    if (reportId === 1) {
      openSummaryPricePlan(company);
    } else if (reportId === 2) {
      openDetailPricePlan(company);
    } else if (reportId === 3) {
      setReportCompany(company);
      setBAQForm(true);
    }
  };

  const closeBAQForm = (submit) => {
    setBAQForm(false);
    if (submit) {
      openBuildAQuote(reportCompany);
    }
  };


  const openSummaryPricePlan = (company) => {
    let url = reportServer + "/v1/PricingExport/PricingSheet/Download/" + company.CustomerUID;
    window.location.href = url;

    //let url = api + "/v1/PricingExports/SummaryPricingSheet/" + company.CustomerUID;
    //downloadExport(url);
  };

  const openDetailPricePlan = (company) => {
    let url = reportServer + "/v1/PricingExport/PricingSheet/" + company.CustomerUID;
    window.location.href = url;

    //let url = api + "/v1/PricingExports/SummaryPricingSheet/" + company.CustomerUID;
    //downloadExport(url);
  };

  const openBuildAQuote = (company) => {
    let url = reportServer + "/v1/PricingExport/BuildAQuote/" + company.CustomerUID;
    window.location.href = url;

    //let url = api + "/v1/PricingExports/SummaryPricingSheet/" + company.CustomerUID;
    //downloadExport(url);
  };

  

  //collapse management
  useEffect(() => {
    setCollapseButtonText(allCollapsed ? 'Expand All' : 'Collapse All');
  }, [allCollapsed]);

  //filter message
  useEffect(() => {
    buildFilterMsg();
  }, [loading, currentPage, totalPages, totalDisplayed, totalRecords, filterTotal]);

  //no records message
  useEffect(() => {
    buildNoRecordsMsg();
  }, [selectedParentID, selectedCompanyID, loading]);


  //load parent/company dependant options for dropdowns
  useEffect(() => {
    fetchSalesReps();

  }, [selectedParentID, selectedCompanyID]);

  //load company cards
  useEffect(() => {
    fetchCompanies();
  }, [selectedParentID, selectedCompanyID, currentPage, salesRepFilter, prospectFilter,  sortOption, displayOption]);

  return(
    <>
      <div className="sticky-top">

        <Nav className='navbar navbar-expand-lg nav-card-actions'>
          <div className='container'>
              <div className='row nav-row page-action-row'>
                <div className='col-sm-12 col-md-6'>
                  <div className='displaying-wrapper row'>
                    <div className='col-sm-12 col-md-3 page-title-wrapper'>
                      <div className='navbar-text page-title'>Companies</div>
                    </div>
                    <div className='col-sm-12 col-md-9'>
                      <div className='navbar-text filter-description'>
                        {filterDescription}
                        {filterTotal !== 0 ?
                          <Button className="remove-filter-link" onClick={resetFilters}>remove filters</Button>
                          : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-sm-12 col-4 col-md-6 align-self-end align-prospect'>
                  <div className='d-flex mobile-button-flow'>  
                    <button className='btn btn-outline-info btn-add-feedback' onClick={openFeedback}>
                      <div className='hidden-sm-down'>Feedback</div>
                    </button>
                    <button className='btn btn-outline-info btn-add-contact' onClick={openCompanyForm}>
                      <div className='hidden-sm-down'>Add Prospect</div>
                    </button>
                  </div>
                </div>
              </div>

          </div>
        </Nav>

        <Nav className='navbar navbar-expand-lg nav-card-dropdowns'>
          <div className='container'>
            <div className='row filter-grid'>
              <div className='col-12 col-sm-12 col-md-6'>
                <div className='row justify-content-start'>
                  <div className='filter-item-salesrep col-auto'>
                    <FloatingLabel controlId="floatingSelect" className="floating-select" label={`Sales Rep.`}>
                      <Select
                        name="filterSalesRep"
                        className="filter-salesrep-companies"
                        classNamePrefix="select"
                        isDisabled={selectedParentID === 0 && selectedCompanyID === 0}
                        isLoading={salesRepsLoading}
                        isClearable={true}
                        isSearchable={true}
                        options={salesReps}
                        value={salesRepFilter}
                        onChange={handleSalesRepFilterChange}
                        filterOption={createFilter({ ignoreAccents: false })} //this for performance
                        components={{ Option: CustomOption }} //this for performance
                      />
                    </FloatingLabel>
                  </div>

                  <div className='filter-item-prospect col-auto'>
                    <FloatingLabel controlId="floatingSelect" className="floating-select" label={`Customers/Prospects`}>
                      <Select
                        className="filter-prospect-companies"
                        classNamePrefix="select"
                        isDisabled={selectedParentID === 0 && selectedCompanyID === 0}
                        isClearable={true}
                        options={prospectFilters}
                        value={prospectFilter}
                        onChange={handleProspectFilterChange}
                      />
                    </FloatingLabel>
                  </div>
                </div>

              </div>
              
              <div className='p-0-desktop col-12 col-sm-12 col-md-6'>
                <div className='row justify-content-end'>
                  <div className='filter-item-collapse col-12 col-md-auto'>
                    <div className='collapse-all-inner'>
                      <Button className='btn-collapse' variant="primary" onClick={handleToggleCollapse}>
                        {collapseButtonText}<i className={collapseButtonText === 'Collapse All' ? "i-collapse fa fa-compress" : "i-collapse fa fa-expand"} aria-hidden="true" />
                      </Button>
                    </div>
                  </div>


                  <div className='p-0-desktop filter-item-display col-12 col-md-auto'>
                    <FloatingLabel controlId="floatingSelect" className="floating-select" label={`Display/Page:`}>
                      <Select
                        className="filter-contact-display"
                        classNamePrefix="select"
                        options={displayOptions}
                        value={displayOption}
                        onChange={handleDisplayChange}
                      />
                    </FloatingLabel>
                  </div>

                  <div className='p-0-desktop filter-item-alpha col-12 col-md-auto'>
                    <FloatingLabel controlId="floatingSelect" className="floating-select" label={`Sort by:`}>
                      <Select
                        className="filter-contact-sort"
                        classNamePrefix="select"
                        options={sortOptions}
                        value={sortOption}
                        onChange={handleSortChange}
                      />
                    </FloatingLabel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Nav>
        {companies && totalRecords > displayOption.value ? (
          <div className='navbar navbar-expand-lg nav-card-pagination'>
            <div className='pagination-wrapper'>
              <Pagination>
                <Pagination.First onClick={handleFirstPage}>
                  <i className="fa fa-angle-double-left pagination-icon-left" aria-hidden="true" />
                  First
                </Pagination.First>
                <Pagination.Prev onClick={handlePrevPage}>
                  <i className="fa fa-angle-left pagination-icon-left" aria-hidden="true" />
                  Previous
                </Pagination.Prev>
                {renderPaginationItems()}
                <Pagination.Next onClick={handleNextPage}>
                  Next
                  <i className="fa fa-angle-right pagination-icon-right" aria-hidden="true" />
                </Pagination.Next>
                <Pagination.Last onClick={handleLastPage}>
                  Last
                  <i className="fa fa-angle-double-right pagination-icon-right" aria-hidden="true" />
                </Pagination.Last>
              </Pagination>
            </div>
          </div>
        ) : (
          <div className="pagination-grid-empty"></div>
        )}
      </div>

      <BAQForm showModal={showBAQForm} closeModal={closeBAQForm} companyInfo={reportCompany}></BAQForm>
      <ContactForm showModal={showContactForm} closeModal={closeContactForm} contactInfo={contactSelected} refreshIndividualOptions={refreshIndividualOptionsToggle}></ContactForm>
      <CompanyForm showModal={showCompanyForm} closeModal={closeCompanyForm} companyInfo={companySelected} openContactForm={openContactFormCallback}></CompanyForm>

      {companies && companies.length > 0 ?
        (
          <div className='container'>
            <div className={loading ? 'cards-loading' : 'cards-loaded'}>
              {companies.map((company, index) => (
                <CompanyCard
                  key={index}
                  company={company}
                  eventKey={String(allCollapsed)}
                  loading={loading}
                  editCompany={(e, value) => openCompanyForm(e, value)}
                  totalSpend={Array.isArray(totalSpends) ? totalSpends.find(item => item.CompanyId === company.CustomerID) || {} : {}}
                  openReport={(e, company, reportId) => openReport(e, company, reportId)}
                  viewActivity={(e, value) => viewActivities(e, value)}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className='container'>
            <AlertElement textBody={noRecordsMessage} clickHandler={resetFilters} />
          </div>
        )}
    </>
  )
};